import Vue from 'vue'
import { AnyObject } from '@/shared/types/builtInTypes'

// new Vue Instance
const eventBusVue = new Vue()

/**
 * event bus interface with two functions
 * 1). register which takes a callback and a callback's key to set it on the vue instance v.on
 * 2). deregister (unsubscribe) the handler which only needs its key to v.off it
 */
interface IEventBus {
  register: (key: string, handler: (...args: unknown[]) => unknown) => void

  deregister: (key: string) => void

  // Method to refresh data
  refreshData: (options?: AnyObject) => void

  // Generic methods for event handling
  $emit: (event: string, ...args: any[]) => void
}

/**
 * event bus class that implements even bus interface
 */
class EventBus implements IEventBus {
  register(event: string, callback: (...args: any[]) => any) {
    eventBusVue.$on(event, callback)
  }

  deregister(event: string, callback?: (...args: any[]) => any) {
    eventBusVue.$off(event, callback)
  }

  refreshData(options?: AnyObject) {
    eventBusVue.$emit('refreshData', options)
  }

  $emit(event: string, ...args: any[]) {
    eventBusVue.$emit(event, ...args)
  }
}

const eventBus = new EventBus()
export default eventBus
